import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_951nzlloyx: FaireBrandEntity = {
  token: "b_951nzlloyx",
  type: "brand",
  name: "Pact",
  avatarUrl:
    "https://cdn.faire.com/fastly/4a1d57e7ab4168dc9676dcd7e0c49c45fe478868d3fb43604947bb617d8e82de.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ded27297cae71dcb507ab8017ef42542f722c6ce816ab22f0f8b7f20318568ab.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4a1d57e7ab4168dc9676dcd7e0c49c45fe478868d3fb43604947bb617d8e82de.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ded27297cae71dcb507ab8017ef42542f722c6ce816ab22f0f8b7f20318568ab.png",
  location: "Boulder, CO, USA",
  minimumOrderDollars: 600,
  rating: 4.8,
  reviewCount: 92,
  isInsider: true,
  description:
    "Made for women and men who believe in the power of self-care, Pact is the accessible, sustainable apparel brand that empowers you to dress well. Giving you clothing that is designed not just to wear out and about, but to live well in – making clean and simple a natural part of your wardrobe and elevating getting dressed to an act of self-care. Because at Pact we believe what you put closest to your skin, day and night, is essential to your wellbeing, and we’ll always design with that in mind. That’s our pact to you.\nSince our inception Pact has put clean fabrics first — simplifying your wardrobe with versatile pieces that are GOTs Certified Organic and Fair Trade, so only the purest cotton stays close to your skin.  \nOur vision is to transform getting dressed into a holistic wellness ritual, redefining everyday apparel as the ultimate expression of personal wellbeing, elevating daily routines through intentionally crafted organic essentials. \n***NOTE: CANNOT RESELL ON AMAZON***\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:43.289Z",
    importedBy: "entity-db-cli",
  },
};
